// Palette de Colette — identite « Horizon », relevee sur le handoff du 2026-08-27
// (docs/design/handoff-horizon/README.md, § Design tokens).
//
// CE QUI A CHANGE, et pourquoi c'est structurant : le fond n'est plus une couleur mais un
// DEGRADE DE CIEL plein ecran, et les cartes ne sont plus blanches mais des voiles
// translucides poses dessus. Une carte opaque au milieu de ce fond casserait tout l'effet
// — ne pas « corriger » en revenant a du blanc.
//
// Chaque jeton rend une VARIABLE CSS, pas une valeur. Les quatre themes (auto, jour,
// nuit, blanc) se choisissent alors en posant un seul attribut sur la racine, et les
// centaines de styles en ligne de l'application suivent sans qu'aucun ne soit touche.
// Les valeurs elles-memes vivent dans styles.css, une seule fois.

const v = (nom: string) => `var(--${nom})`;

export const C = {
  // --- Fonds et voiles (suivent le theme) ---
  /** Le fond de page : conserve pour les rares surfaces qui doivent s'y fondre. */
  page: v('page'),
  /** Le voile ordinaire d'une carte. Translucide, JAMAIS opaque. */
  carte: v('card'),
  /** Un voile plus present : carte d'appel, bloc de question. */
  carteForte: v('card-strong'),
  /** Un voile a peine pose : rail d'onglets, blocs secondaires. */
  carteDouce: v('card-soft'),
  /** Le rail d'une jauge. */
  rail: v('track'),

  // --- Texte (suit le theme) ---
  encre: v('ink'),
  /** L'encre posee SUR de l'encre (le chiffre du jour choisi, sur son disque plein). */
  encreInverse: v('ink-inverse'),
  secondaire: v('sub'),
  tertiaire: v('faint'),

  // --- Traits (suivent le theme) ---
  bordure: v('card-border'),
  bordureForte: v('card-border-strong'),
  inactif: v('card-border'),

  // --- Accent : sable la nuit, bleu sur fond blanc ---
  violet: v('accent'),
  violetTexte: v('accent'),
  violetFond: v('accent-soft'),
  violetBordure: v('card-border-strong'),
  accent: v('accent'),
  accentDoux: v('accent-soft'),

  // --- Menthe : ce qui est valide, fait, connecte ---
  menthe: v('mint'),
  mentheTexte: v('mint'),
  mentheFond: v('mint-soft'),
  mentheBordure: v('mint-border'),

  // --- Corail : alerte, limite, ce qui manque ---
  corailTexte: v('warn'),
  corailFond: v('alert-bg'),
  corailBordure: v('alert-border'),

  /** Le fond de la bande collante des jours (avec un flou derriere). */
  bandeCollante: v('sticky-bg'),

  // --- Surfaces FIXES : elles ne suivent PAS le theme (handoff, § Design tokens) ---
  // La barre de navigation et les feuilles modales restent blanches en permanence : ce
  // sont les deux seuls plans qui ne flottent pas sur le ciel.
  surfaceFixe: '#FFFFFF',
  encreFixe: '#2D3436',
  secondaireFixe: '#6E7377',
  tertiaireFixe: '#9AA0A5',
  bordureFixe: '#EEECE7',
  champFixe: '#F6F4F0',
  /** L'onglet actif de la barre et des feuilles. */
  corailFixe: '#F27059',
  corailFonceFixe: '#C25538',
  /** Le voile pose derriere une feuille modale. */
  voile: 'rgba(20,16,45,0.5)',
  /** Le bandeau de confirmation, 20 px au-dessus de la barre. */
  bandeau: 'rgba(28,22,52,0.94)',
} as const;

/**
 * L'action principale : bouton central, boutons qui appellent l'IA, interrupteurs actifs.
 * HORS THEME — c'est la signature de Colette, elle ne change jamais de couleur.
 */
export const DEGRADE_ACTION = 'linear-gradient(140deg, #FFB36B, #F27059)';
export const OMBRE_ACTION = '0 8px 20px rgba(242,112,89,0.45)';

/** La coche validee dans une case : trait fonce sur menthe pleine. */
export const MENTHE_PLEINE = '#9FF0D2';
export const TRAIT_COCHE = '#1E4534';

/**
 * La couleur d'un jour de la semaine, FIXE (0 = dimanche, comme `Date.getDay()`).
 * Sert au filet vertical des sections du Planning et au point sous les jours.
 */
export const COULEUR_DU_JOUR = [
  '#9AA0A5', // dimanche
  '#8B7BE8', // lundi
  '#3FBFA0', // mardi
  '#E8C34A', // mercredi
  '#F27059', // jeudi
  '#B7A6EA', // vendredi
  '#5AA8E0', // samedi
] as const;

export const POLICE_TITRE = "'Outfit', system-ui, sans-serif";
export const POLICE_CORPS = "'Nunito Sans', 'Segoe UI', system-ui, sans-serif";
